import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Icon } from "@/shared/ui/atoms";
import { HeaderLanguageButton } from "@/shared/ui/molecules";
import { getLocale } from "next-intl/server";
const MainHeader = async () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = await getLocale();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const locale = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "--height": 44
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <header className="dynamic-size sticky top-0 z-[101] pl-4 pr-[14px] flex items-center justify-between w-full bg-gray-100" style={t1 as React.CSSProperties}><Link href={`/${locale}`}><Icon src="/icons/logo.svg" alt={"\uB9AC\uBDF0\uB4DC"} width={125} height={20} priority={true} /></Link></header>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default MainHeader;